import React, { useEffect, useContext } from "react";
import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  TextField,
  Button,
  FormControl,
  InputLabel,
  MenuItem,
} from "@mui/material";
import { RHFSelect } from "../RFHSelect/RFHSelect";
import { getColors } from "../../themes/theme";
import { ThemeContext } from "../../context/ThemeContext";
import { useForm, FormProvider } from "react-hook-form";

export const EditVideoDialog = ({
  open,
  onClose,
  onSave,
  onRemove,
  videoData,
  allVideos,
}) => {
  const methods = useForm({
    displayname: videoData?.displayname,
    videolink: videoData?.videolink,
    vimeolink: videoData?.vimeolink,
  });
  const {
    register,
    handleSubmit,
    setValue,
    formState: { errors },
  } = methods;
  const { darkMode } = useContext(ThemeContext);

  useEffect(() => {
    if (videoData) {
      setValue("displayname", videoData?.displayname);
      setValue("videolink", videoData?.videolink);
      setValue("vimeolink", videoData?.vimeolink);
    }
  }, [videoData, setValue]);

  const onSubmit = (data) => {
    const editedVideoData = {
      ...videoData,
      displayname: data.displayname,
      videolink: data.videolink,
      vimeolink: data.vimeolink,
    };
    onSave(editedVideoData);
    onClose();
  };

  const handleDeleteClicked = () => {
    onRemove(videoData.id);
  };

  return (
    <Dialog
      open={open}
      onClose={onClose}
      fullWidth
      maxWidth="sm"
      onClick={(e) => {
        e.stopPropagation();
      }}
    >
      <DialogTitle sx={{ fontSize: "30px", pb: 0 }}>Edit Video</DialogTitle>
      <FormProvider {...methods}>
        <form onSubmit={handleSubmit(onSubmit)}>
          <DialogContent sx={{ pt: 0 }}>
            <FormControl fullWidth margin="normal">
              <TextField
                label="Video Name"
                placeholder="Enter Video Name"
                {...register("displayname", {
                  required: "Video Name is required",
                })}
                error={!!errors.displayname}
                helperText={errors.displayname?.message}
              />
            </FormControl>

            {/* Frequency Dropdown */}
            <FormControl fullWidth margin="normal">
              <InputLabel>Video Link</InputLabel>
              <RHFSelect
                name="videolink"
                error={!!errors.videolink}
                helperText={errors.videolink?.message}
              >
                {[...new Set(allVideos.map((video) => video.videolink))].map(
                  (uniqueLink) => (
                    <MenuItem key={uniqueLink} value={uniqueLink}>
                      {uniqueLink}
                    </MenuItem>
                  )
                )}
              </RHFSelect>
            </FormControl>

            <FormControl fullWidth margin="normal">
              <TextField
                label="Vimeo Link"
                multiline
                rows={4}
                placeholder="Enter Vimeo Link"
                {...register("vimeolink", {})}
                error={!!errors.vimeolink}
                helperText={errors.vimeolink?.message}
              />
            </FormControl>
          </DialogContent>
          <DialogActions sx={{ px: 3, pb: 2, pt: 0 }}>
            <Button
              sx={{
                borderRadius: "5px",
                fontFamily: "Poppins",
                fontSize: "18px",
                fontWeight: 500,
                color: darkMode
                  ? getColors.appBarBgLight
                  : getColors.appBarBgDark,
                px: 6,
                py: "11px",
                textAlign: "center",
                "&: hover": {
                  background: "none",
                  color: getColors.primaryMain,
                },
                mr: 2,
              }}
              onClick={onClose}
            >
              Cancel
            </Button>
            <Button
              variant="contained"
              sx={{
                borderRadius: "5px",
                fontFamily: "Poppins",
                fontSize: "18px",
                fontWeight: 500,
                px: 6,
                py: "11px",
                textAlign: "center",
                mr: 2,
              }}
              onClick={handleDeleteClicked}
            >
              Delete
            </Button>
            <Button
              type="submit"
              variant="contained"
              sx={{
                borderRadius: "5px",
                fontFamily: "Poppins",
                fontSize: "18px",
                fontWeight: 500,
                px: 6,
                py: "11px",
                textAlign: "center",
              }}
            >
              Save
            </Button>
          </DialogActions>
        </form>
      </FormProvider>
    </Dialog>
  );
};
